import { render, staticRenderFns } from "./refreshMessage.vue?vue&type=template&id=15dfa28d&scoped=true&"
import script from "./refreshMessage.vue?vue&type=script&lang=js&"
export * from "./refreshMessage.vue?vue&type=script&lang=js&"
import style0 from "./refreshMessage.vue?vue&type=style&index=0&id=15dfa28d&prod&lang=stylus&"
import style1 from "./refreshMessage.vue?vue&type=style&index=1&id=15dfa28d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dfa28d",
  null
  
)

export default component.exports